module.exports = __webpack_public_path__ + "img/sample_bg_05.4c2a865f.jpg";